import styled from "styled-components";

import { IconButton } from "../../button";

export const IconButtonStyled = styled(IconButton)`
    margin-left: 5px;
    // prevent the button from pushing the whole field upwards (because the button is taller than the field)
    margin-bottom: -5px;
    bottom: 3px;
`;
